
// Action: file_editor create /app/frontend/src/pages/PortfolioPage.js --file-text "
import React from 'react';
import Portfolio from '../components/Portfolio';

const PortfolioPage = () => {
  return (
    <div data-testid="portfolio-page" className="pt-24">
      <Portfolio />
    </div>
  );
};

export default PortfolioPage;

// Observation: Create successful: /app/frontend/src/pages/PortfolioPage.js